import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Session} from 'src/app/interfaces/session-data';
import gsap from 'gsap';
import {PaymentService} from '../../services/payment/payment.service';
import {DOCUMENT} from '@angular/common';
import {TransactionService} from '../../services/transaction/transaction.service';
import {TransactionStatus} from '../../interfaces/payment-option';
import {environment} from 'src/environments/environment';
import {ForwardingService} from '../../services/forwarding/forwarding.service';
import {GetPostbackFormDataResponse} from '../../interfaces/PostbackFormData/GetPostbackFormDataResponse';
import {GoogleAnalyticsService} from '../../services/google-analytics/google-analytics.service';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

export interface Error {
  error: string;
  errorDescription: string;
  status: number;
}

export interface TransactionRef {
  ref: string;
}

@Component({
  selector: 'app-error-handling',
  templateUrl: './error-handling.component.html',
  styleUrls: ['./error-handling.component.scss']
})
export class ErrorHandlingComponent implements OnInit {

  errorText: string;
  error: Error;
  errorDescription: string;
  sessionData: Session;
  redirectFailedURL: string;
  transactionStatus: TransactionStatus;
  transactionRef: TransactionRef;
  url;
  transactionId;
  paymentType;
  postbackData: GetPostbackFormDataResponse;
  mobile;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private paymentService: PaymentService,
    private breakpointObserver: BreakpointObserver) {
      this.breakpointObserver.observe(
        Breakpoints.HandsetPortrait
      ).subscribe(result => this.mobile = result.matches);
  }

  ngOnInit(): void {

    gsap.set('svg', { visibility: 'visible' });
    gsap.to('#headStripe', {
      y: 0.5,
      rotation: 1,
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut',
      duration: 1
    });
    gsap.to('#spaceman', {
      y: 0.5,
      rotation: 1,
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut',
      duration: 1
    });
    gsap.to('#craterSmall', {
      x: -3,
      yoyo: true,
      repeat: -1,
      duration: 1,
      ease: 'sine.inOut'
    });
    gsap.to('#craterBig', {
      x: 3,
      yoyo: true,
      repeat: -1,
      duration: 1,
      ease: 'sine.inOut'
    });
    gsap.to('#planet', {
      rotation: -2,
      yoyo: true,
      repeat: -1,
      duration: 1,
      ease: 'sine.inOut',
      transformOrigin: '50% 50%'
    });
    gsap.to('#starsBig g', {
      rotation: 'random(-30,30)',
      transformOrigin: '50% 50%',
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut'
    });
    gsap.fromTo(
      '#starsSmall g',
      { scale: 0, transformOrigin: '50% 50%' },
      { scale: 1, transformOrigin: '50% 50%', yoyo: true, repeat: -1, stagger: 0.1 }
    );
    gsap.to('#circlesSmall circle', {
      y: -4,
      yoyo: true,
      duration: 1,
      ease: 'sine.inOut',
      repeat: -1
    });
    gsap.to('#circlesBig circle', {
      y: -2,
      yoyo: true,
      duration: 1,
      ease: 'sine.inOut',
      repeat: -1
    });
    gsap.set('#glassShine', { x: -68 });
    gsap.to('#glassShine', {
      x: 80,
      duration: 2,
      rotation: -30,
      ease: 'expo.inOut',
      transformOrigin: '50% 50%',
      repeat: -1,
      repeatDelay: 8,
      delay: 2
    });
    this.redirectFailedURL = sessionStorage.getItem('redirectFailedURL');
    this.route.queryParams.subscribe((query: Error) => {
      this.error = query;
      this.errorText = 'Session Has Expired';
      this.errorDescription = 'Please return to the merchant and retry the payment';
      for (const prop in this.error) {
        if (this.error.hasOwnProperty(prop)) {
          this.errorText = this.error.error;
          this.errorDescription = this.error.errorDescription;
        }
      }
    });

    const baseUrl = environment.production ? '/channel-virtual/api/v1' : environment.baseUrl;
    this.url = `${baseUrl}/payment/postback/${sessionStorage.getItem('sessionToken')}`;

    if (!sessionStorage.getItem('sessionToken')) {

    } else {
      this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'))
        .subscribe((dataPostback: GetPostbackFormDataResponse) => {
          this.postbackData = dataPostback;
          if (this.postbackData.errorMessage) {
            this.errorDescription = this.postbackData.errorMessage;
          }
        });
    }

  }

  submitForm(form: HTMLFormElement) {
    form.submit();
  }

}
